import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	/**
	 * @param {*} id
	 */
	findOne (id, params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/document/acts/' + id, {
				params: params,
				responseType: 'blob'
			}).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/document/act.js